import { SingleEvent } from "@/features/events/components/single/SingleEvent.fetcher";
import { PageDoesntExist } from "@/pageDoesntExist";
import EventsPage from "@/pages/Events/EventsPage";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { siteRoutes } from "../siteRoutesList";
import { SingleZone } from "@/features/zones/components/single/SingleZone.fetcher";
import ZonesPage from "@/pages/Zones/ZonesPage";
import { SingleChallengePageRenderLogic } from "@/features/challenge/pages/SingleChallengePageRenderLogic";
import { NewsOverview, SingleNews } from "@/features/news";
import ChallengesPage from "@/pages/Challenges/ChallengesPage";

export const zoneRoutes = [
  {
    element: brand.hasFeature.zones ? ZonesPage : PageDoesntExist,
    path: siteRoutes["zones"],
  },
  {
    element: brand.hasFeature.zones ? SingleZone : PageDoesntExist,
    path: `${siteRoutes["zone"]}:slug`,
  },
  {
    element: brand.hasFeature.zones ? EventsPage : PageDoesntExist,
    path: `${siteRoutes["zone"]}:slug${siteRoutes["events"]}`,
  },
  {
    element:
      brand.hasFeature.zones && brand.hasFeature.events
        ? SingleEvent
        : PageDoesntExist,
    path: `${siteRoutes["zone"]}:zoneId${siteRoutes["eventAndSlug"]}:slug`, // route to news overview
  },

  // * Zone Specific News
  {
    element:
      brand.hasFeature.zones && brand.hasFeature.news
        ? NewsOverview
        : PageDoesntExist,
    path: `${siteRoutes["zone"]}:slug${siteRoutes["newsAndSlug"]}`,
  },
  {
    element:
      brand.hasFeature.zones && brand.hasFeature.news
        ? SingleNews
        : PageDoesntExist,
    path: `${siteRoutes["zone"]}:zoneId${siteRoutes["newsAndSlug"]}:slug`, // route to news overview
  },

  // * Zone Specific Challenges
  {
    element:
      brand.hasFeature.challenges && brand.hasFeature.events
        ? ChallengesPage
        : PageDoesntExist,
    path: `${siteRoutes["zone"]}:slug${siteRoutes["challenges"]}`,
  },
  {
    element:
      brand.hasFeature.challenges && brand.hasFeature.events
        ? SingleChallengePageRenderLogic
        : PageDoesntExist,
    path: `${siteRoutes["zone"]}:zoneId${siteRoutes["challengesAndSlug"]}:slug`, // route to news overview
  },
];
